
import { defineComponent } from "vue";
import gamesConfirmCreateNamespaceModal from '@/modules/games/components/modals/gamesConfirmCreateNamespaceModal.vue';
import qrcode from 'qrcode-generator';
import GameReleaseService from '@/services/GameReleaseService';
import GameService from "@/services/GameService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import store from "@/store/index";
import { NamespaceHttp, NamespaceId, NetworkHttp, RegisterRootNamespaceTransactionBuilder, RegisterSubNamespaceTransactionBuilder, RegisterNamespaceTransaction, TransactionBuilderFactory, AccountHttp, Address, AggregateTransaction, Convert, Deadline, PublicAccount, UInt64 } from "tsjs-xpx-chain-sdk";
import { Peer } from "peerjs";
import OnboardingChecklistService from "@/services/OnboardingChecklistService";

export default defineComponent({
  name: 'gamesUpdateSubmitMainnetGameComponent',
  components: {
    gamesConfirmCreateNamespaceModal
  },
  props: {
    status: Number
  },
  data: function () {
    return {
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      mainnetJwtToken: store.getters["auth/mainnetJwtToken"] ?? "",
      isNamespaceFound: false,
      namespaceName: '',
      levels: [],
      duration: 0,
      isMultisig: false,
      qr: '',
      isQRModalShow: false,
      isDisabledModalConfirmSubmitButton: false,
      showUploadingLoader: false,
    };
  },

  methods: {
/* Generate QR to create namespace */
    async publishGameMainnet() {
      this.$emit('showLoader');

      // search for namespace in sdk
      if(!this.isNamespaceFound){
        const publicAcc = PublicAccount.createFromPublicKey(this.userData.mainnetPublicAddress, store.getters['config/getMainnetNetworkType']);
        // create new namespace
        let transactionBuilderFactory = new TransactionBuilderFactory();
        transactionBuilderFactory.networkType = store.getters['config/getMainnetNetworkType'];
        let aggNSTxn = [];
        if(this.levels.length == 1){
          let txnBuilder: RegisterRootNamespaceTransactionBuilder = transactionBuilderFactory.registerRootNamespace();
          let regNamespaceTransaction = txnBuilder.deadline(Deadline.create())
            .namespaceName(this.namespaceName)
            .duration(UInt64.fromUint(this.duration)) //this.duration
            .build();
          aggNSTxn.push(regNamespaceTransaction.toAggregate(publicAcc));
        }else{
          let namespaceHttpTestnet = new NamespaceHttp(store.getters['config/getTestnetApi']);
          let namespaceHttpMainnet = new NamespaceHttp(store.getters['config/getMainnetApi']);
          let index = 0;
          for await (const level of this.levels) {
            if(index == 0){
              const nsMainnet = await namespaceHttpMainnet.getNamespacesName([level.id]).toPromise();
              if(nsMainnet){
                const nsTestnet = await namespaceHttpTestnet.getNamespacesName([level.id]).toPromise();
                let txnBuilder: RegisterRootNamespaceTransactionBuilder = transactionBuilderFactory.registerRootNamespace();
                let regNamespaceTransaction = txnBuilder.deadline(Deadline.create())
                  .namespaceName(nsTestnet[0].name)
                  .duration(UInt64.fromUint(this.duration)) //this.duration
                  .build();
                aggNSTxn.push(regNamespaceTransaction.toAggregate(publicAcc));
              }
            }else{
              const nsMainnet = await namespaceHttpMainnet.getNamespacesName([level.id]).toPromise();
              if(nsMainnet){
                const nsTestnet = await namespaceHttpTestnet.getNamespacesName([level.id]).toPromise();
                let txnBuilder: RegisterSubNamespaceTransactionBuilder = transactionBuilderFactory.registerSubNamespace();
                let regSubNamespaceTransaction = txnBuilder.deadline(Deadline.create())
                  .namespaceName(nsTestnet[0].name)
                  .parentNamespace(this.levels[index - 1]) //this.duration
                  .build();
                aggNSTxn.push(regSubNamespaceTransaction.toAggregate(publicAcc));
              }
            }
            ++index;
          }
        }
        let aggregateTx = this.isMultisig?
        transactionBuilderFactory.aggregateBonded().innerTransactions(aggNSTxn).build():
        transactionBuilderFactory.aggregateComplete().innerTransactions(aggNSTxn).build()

        const peer = new Peer();
        peer.on("open", (id) => {
          // create QR
          const qrCode = qrcode(0, 'H');
          let data = {
            payload:aggregateTx.serialize(),
            type:'sign',
            recvId: peer.id,
            generationHash: store.getters['config/getMainnetGenerationHash'],
            callbackUrl: null
          }
          qrCode.addData(JSON.stringify(data));
          qrCode.make();
          this.qr = qrCode.createSvgTag({scalable: true});
        });

        peer.on("connection", (conn) => {
          // console.log("connected to " + conn.peer);
          conn.on("data", (data: any) => {
            conn.send("success");
          });
        });
        this.isQRModalShow = true;
        this.$emit('hideLoader');
      }else{
        await this.saveGameMainnet();
      }
    },

    async init() {
      let namespaceHttpTestnet = new NamespaceHttp(store.getters['config/getTestnetApi']);
      let namespaceHttpMainnet = new NamespaceHttp(store.getters['config/getMainnetApi']);
      let ns_uint64 = UInt64.fromHex(this.$route.params.gameId);
      let namespaceId = new NamespaceId([ns_uint64.lower, ns_uint64.higher]);
      const nsTestnet = await namespaceHttpTestnet.getNamespacesName([namespaceId]).toPromise();
      const nsMainnet = await namespaceHttpMainnet.getNamespacesName([namespaceId]).toPromise();

      if(nsMainnet.length > 0){
        this.isNamespaceFound = true;
      }else{
        this.isNamespaceFound = false;
      }
      this.namespaceName = nsTestnet[0].name;
      const nsInfo = await namespaceHttpTestnet.getNamespace(namespaceId).toPromise();
      this.levels = nsInfo.levels;
      // this.endHeight = nsInfo.endHeight.compact();
      // this.startHeight = nsInfo.startHeight.compact();
      // this.duration = this.endHeight - this.startHeight;
      this.duration = 4*60*24*14;
      // console.log(this.duration)

      let accountHttp = new AccountHttp(store.getters['config/getMainnetApi']);

      let multisigInfo = await accountHttp.getMultisigAccountInfo(Address.createFromRawAddress(this.userData.mainnetWalletAddress)).toPromise()
      this.isMultisig = multisigInfo.cosignatories.length>0?true:false;
    },

    /* save game info in mainnet */
    async saveGameMainnet(){
      this.isDisabledModalConfirmSubmitButton = true;
      this.showUploadingLoader = true;
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        this.$emit('showLoader');
        let gameId = this.$route.params.gameId;
        if(this.status == 4){
          GameReleaseService.publishGame(gameId, this.userData.userId, this.mainnetJwtToken, 'mainnet')
          .then((response: ResponseData) => {
            Helper.toastSuccessHandling(response.data['message']);
            this.$emit('hideLoader');
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
            this.$emit('hideLoader');
          });
        }else{
          await GameReleaseService.importGameToMainnet(gameId, this.userData.userId, this.jwtToken, 'testnet')
            .then((response: ResponseData) => {
              if(this.isNamespaceFound){
                this.$emit('hideLoader');
              }
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
              // // this.showLoader = false;
              this.$emit('hideLoader');
              return false;
            });

          if(!this.isNamespaceFound){
            await GameService.linkedNamespaceToGameMainnet(gameId, this.namespaceName, this.userData.userId, this.mainnetJwtToken).then((response: string) => {
              Helper.toastSuccessHandling(response);
              // this.showLoader = false;
              this.$emit('hideLoader');
            }).catch((error) => {
              Helper.endpointErrorHandling(error);
              // this.showLoader = false;
              this.$emit('hideLoader');
            });
          }
          this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
          this.isDisabledModalConfirmSubmitButton = false;
          this.showUploadingLoader = false;
          this.isQRModalShow = false;
        }
      }
    },

    updateOnboardingChecklist(userId: string, token: string) {
      OnboardingChecklistService.getOnboardingChecklist(userId, token)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, 11, userId, token);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    },
  },

  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
  },

  mounted() {
    if(this.userData.mainnetPublicAddress){
      this.init();
    }
  },
});
